import { FC, ReactNode } from 'react';
import Background from '@/components/common/Background/Background';
import Container from '@/components/common/Container/Container';
import Heading from '@/components/common/Heading/Heading';
import Section from '@/components/common/Section/Section';
import Consultation from '../../Index/Сonsultation/Consultation';

interface IServicesLayoutProps {
  children: ReactNode;
}

const ServicesLayout: FC<IServicesLayoutProps> = ({ children }) => {
  return (
    <>
      {children}
      <Background>
        <Container>
          <Section className="lg:pb-[50px]">
            <Heading headingLevel="h2" className="visually-hidden">
              Consultation by project!
            </Heading>
            <Consultation />
          </Section>
        </Container>
      </Background>
    </>
  );
};

export default ServicesLayout;
